import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { CreateComponent as ProjectCreateComponent } from './views/home/projects/create/create.component';
import { EditComponent as ProjectEditComponent } from './views/home/projects/edit/edit.component';
import { ProjectsComponent } from './views/home/projects/projects.component';
import { UsersComponent } from './views/home/users/users.component';
import { AuthGuard } from './helpers/auth.guard';
import { ResetPasswordComponent } from './views/auth/reset-password/reset-password.component';
import { EditComponent as ProfileEditComponent } from './views/home/users/edit/edit.component';
import { ViewUserComponent } from './views/home/users/view-user/view-user.component';
import { DronesComponent } from './views/home/drones/drones.component';
import { ListDroneComponent } from './views/home/drones/list-drone/list-drone.component';
import { CreateDroneComponent } from './views/home/drones/create-drone/create-drone.component';
import { UploadMetaDataComponent } from './views/home/projects/upload-meta-data/upload-meta-data.component';
import { NotificationsComponent } from './views/home/notifications/notifications.component';
import { NotificationSettingsComponent } from './views/home/notifications/notification-settings/notification-settings.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Home',
      icon: 'icon-home',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'projects',
      },
      {
        path: 'users',
        loadChildren: () => import('./views/home/users/users.module').then(m => m.UsersModule)
      },
      {
        path: 'profile',
        component: UsersComponent,
        data: {
          breadcrumb: 'Profile',
        },
        children: [
          {
            path: '',
            component: ViewUserComponent,
          },
          {
            path: 'edit',
            component: ProfileEditComponent,
            data: {
              breadcrumb: 'Edit Profile',
            },
          },
        ],
      },
      {
        path: 'notifications',
        component: DronesComponent,
        data: {
          breadcrumb: 'Notification',
        },
        children: [
          {
            path: '',
            component: NotificationsComponent
          },
          {
            path: 'settings',
            component: NotificationSettingsComponent,
            data: {
              breadcrumb: 'Settings',
            },
          }
        ]
      },
      {
        path: 'drones',
        component: DronesComponent,
        data: {
          breadcrumb: 'Drones',
        },
        children: [
          {
            path: '',
            component: ListDroneComponent,
          },
          {
            path: 'create',
            component: CreateDroneComponent,
            data: {
              breadcrumb: 'Create Drone',
            },
          },
          {
            path: 'edit/:id',
            component: CreateDroneComponent,
            data: {
              breadcrumb: 'Edit Drone',
            },
          },
          {
            path: 'view/:id',
            component: ViewUserComponent,
          },
        ],
      },
      {
        path: 'projects',
        component: ProjectsComponent,
        children: [
          {
            path: 'create',
            component: ProjectCreateComponent,
            data: {
              breadcrumb: 'Create Project',
            },
          },
          {
            path: 'upload',
            component: UploadMetaDataComponent,
            data: {
              breadcrumb: 'Upload Metadata',
            },
          },
        ],
      },
      {
        path: 'projects/:id',
        component: ProjectsComponent,
        data: {
          breadcrumb: '',
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'details'
          },
          {
            path: 'edit',
            component: ProjectEditComponent,
            data: {
              breadcrumb: 'Edit Project',
            },
          },
          {
            path: 'details',
            loadChildren: () => import('./views/home/projects/details/details.module').then(m => m.DetailsModule)
          },
          {
            path: 'tables',
            loadChildren: () => import('./views/home/projects/tables/tables.module').then(m => m.TablesModule)
          }
        ],
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'location-task-charts/:id',
        loadChildren: () => import('./views/location-task-chart/location-task-chart.module').then(m => m.LocationTaskChartModule)
      }
    ],
  },
  {
    path: 'login',
    loadChildren: () => import('./views/auth/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'reset-password/:id',
    component: ResetPasswordComponent,
    data: {
      breadcrumb: 'reset-password',
    },
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
